import { useQuery } from '@tanstack/react-query'
import { Percentage } from '@/domain/types/NumericValues'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { MERKL_BASE } from '@/config/consts'

export type ExtraIncentivesUSDC = {
  apr: number
  description: string
}

export function getExtraIncentivesUSDCAdjustment(
  tokenSymbol: TokenSymbol | string,
  extraIncentivesUSDC?: ExtraIncentivesUSDC | null,
) {
  if (tokenSymbol !== 'USDC') return undefined
  if (!extraIncentivesUSDC?.apr) return undefined

  return Percentage(-extraIncentivesUSDC.apr / 100, true, true)
}

export function applyExtraIncentivesUSDCToBorrowAPY(
  apy: Percentage | undefined,
  tokenSymbol: TokenSymbol | string,
  extraIncentivesUSDC?: ExtraIncentivesUSDC | null,
) {
  const bonusAPY = extraIncentivesUSDC ? getExtraIncentivesUSDCAdjustment(tokenSymbol, extraIncentivesUSDC) : undefined
  const totalAPY = apy && bonusAPY ? Percentage(apy.plus(bonusAPY), true, true) : apy

  return {
    baseAPY: apy,
    bonusAPY,
    totalAPY,
  }
}

export function useExtraIncentivesUSDC() {
  const { data: extraIncentivesUSDC } = useQuery<ExtraIncentivesUSDC | null | undefined>({
    queryKey: ['extraIncentivesUSDC'],
    queryFn: async () => {
      const response = await fetch(`${MERKL_BASE}/opportunities/12951423112444096259`)

      if (!response.ok) {
        return null
      }

      const data = await response.json()
      const apr = Number(data.apr ?? 0)

      return apr
        ? {
            apr,
            description: `Earn ${apr.toFixed(2)}% APR on your net borrowing position (USDC borrow minus USD₮0, thBILL, USDC, USDHL, sUSDe, USDH supplies). Provided by Gauntlet.`,
          }
        : null
    },
  })

  return extraIncentivesUSDC
}
